export class UserProfile {
    Id_User: number;
    Id_Profile: number;
    Description: string;
    FullName: string;
    IsShowCal: number;
    IsCalcCal: number;
    CalorificValuePerDay: number;
    ProteinsPerDay: number;
    FatsPerDay: number;
    CarbohydratesPerDay: number;
    PortionWeight: number;
}





// WEBPACK FOOTER //
// ./src/app/shared/models/profile-model.ts